import styled from "styled-components";

export const WrapperTypeProduct = styled.div`
    display : flex;
    align-items: center;
    gap: 90px;
    justify-content: flex-start;
    border-bottom: 2px solid #ccc;
    height: 40px;
`